import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function DemoBackBar({ accentColor = "#D4AF37", demoName = "Demo" }) {
  return (
    <div
      className="sticky top-0 z-50 w-full"
      style={{
        background:
          "linear-gradient(to right, rgba(0,0,0,0.92), rgba(10,10,10,0.92))",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        backdropFilter: "blur(14px)",
      }}
      data-testid="demo-back-bar"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-3 flex items-center justify-between text-white">
        <div className="flex items-center gap-2 sm:gap-3 min-w-0">
          <span
            className="inline-block h-2 w-2 rounded-full flex-shrink-0"
            style={{ background: accentColor }}
          />
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.25em] text-white/60">
            SS Demo Showcase ·
          </span>
          <span className="text-[11px] sm:text-[12px] tracking-wide text-white/85 truncate">{demoName}</span>
        </div>
        <Link
          to="/demos"
          className="inline-flex items-center gap-2 text-[11px] sm:text-xs tracking-wide text-white/85 hover:text-agency-gold transition-colors flex-shrink-0"
          data-testid="back-to-ss-link"
        >
          <ArrowLeft size={14} /> <span className="hidden xs:inline">Back to SS</span><span className="hidden sm:inline"> Website</span><span className="xs:hidden sm:hidden">Back</span>
        </Link>
      </div>
    </div>
  );
}
